// extracted by mini-css-extract-plugin
export default {"container":"SymbolCollection-module--container--Gu95A"};